import { CountryCode } from '@customer-apps/shared/enums';
import { Mask } from '@customer-apps/shared/interfaces';

export const getPostalCodeMask = (countryCode: string): Mask => {
    const pattern = countryCode === CountryCode.DE ? '00000' : '0000';
    return { pattern };
};
